// extracted by mini-css-extract-plugin
export default {"identicon":"Ni3Ohhii3SDPBIj2pLnw"};